import React from 'react';
import { useAuth } from 'react-oidc-context';


const LogoutScreen = () => { 
  const auth = useAuth();

  const signOutRedirect = () => {
    auth.removeUser()
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const logoutUri = process.env.REACT_APP_COGNITO_LOGOUT_URI;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return <div  className="flex flex-col items-center justify-center h-screen bg-gray-100">Loading...</div>;
  }

  if (auth.error) {
    return <div className="flex flex-col items-center justify-center h-screen bg-gray-100">Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        {/* <pre> Hello: {auth.user?.profile.email} </pre>
        <pre> ID Token: {auth.user?.id_token} </pre>
        <pre> Access Token: {auth.user?.access_token} </pre>
        <pre> Refresh Token: {auth.user?.refresh_token} </pre> */}
        <button className="px-6 py-2 bg-black text-white font-semibold text-2xl rounded-lg shadow hover:bg-gray-800 transition duration-200" onClick={() => signOutRedirect()}>Sign out</button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <button className="px-6 py-2 bg-black text-white font-semibold text-2xl rounded-lg shadow hover:bg-gray-800 transition duration-200" onClick={() => auth.signinRedirect()}>Sign in</button>
    </div>
  );
};

export default LogoutScreen;